import { render, staticRenderFns } from "./CardMemberSmall.vue?vue&type=template&id=193f975e&scoped=true"
import script from "./CardMemberSmall.vue?vue&type=script&lang=js"
export * from "./CardMemberSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193f975e",
  null
  
)

export default component.exports